module.exports = __webpack_public_path__ + "img/gift.319f2905.png";